/**
 * TextareaFieldType — długi tekst. Storage: PG TEXT.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function TextareaInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  return (
    <textarea
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      autoFocus={autoFocus}
      rows={3}
      placeholder={field.description ?? undefined}
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary placeholder-text-muted focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const TextareaFieldType: FieldTypeDefinition = {
  type: 'textarea',
  renderInput: (props) => <TextareaInput {...props} />,
  renderCell: (_field, value) => {
    if (typeof value !== 'string') return '';
    return value.length > 80 ? value.slice(0, 80) + '…' : value;
  },
  defaultValue: '',
};
